<template>
  <div>
    <div>
      <top-menu 
        :backVisible="true"
        :homeVisible="true"
        :aboutVisible="false"
      >
      </top-menu>
    </div>
    <div>
      <v-container fluid class="ma-0 pa-0 mt-6">
        <v-row dense>
          <v-col class="ma-0 pa-0">
            <v-card flat class="ma-0 pa-0">
              <v-form v-model="valid" ref="main" class="ma-0 pa-0">
                <v-card-title class="justify-center ma-0 pa-0 mb-4"><div ><label class="font-weight-black blue--text text--darken-4 title">Yosemite Callsigns</label></div></v-card-title>
                <v-card-text class="text-center">
                  <div>
                    <div v-if="showError==true" class="mb-2"><label class="font-weight-black red--text text--darken-2 subtitle-1">No Search Criteria Found ...</label></div>
                      <v-text-field
                        label="Callsign"
                        dense
                        v-model="search.callsign"
                        prefix="Yosemite"
                        placeholder=""
                        required
                        outlined
                        :rules="[rules.numeric, rules.counter]"
                        :hint="'(Up to 4 digit numbers maximum)'"
                        @change="setFormConditions('callsign')"
                      ></v-text-field>
                      <v-text-field
                        label="CAPID/Charter"
                        dense
                        placeholder="Select Type"
                        v-model="search.id"
                        outlined
                        :hint="'(###### or PCR-CA-###)'"
                        @change="setFormConditions('id')"
                      ></v-text-field>
                      <br />
                      <v-text-field
                        label="Name"
                        dense
                        placeholder=""
                        v-model="search.name"
                        outlined
                        :hint="'(Member/Unit)'"
                        @change="setFormConditions('name')"
                      ></v-text-field>

                      <v-select
                        label="Type"
                        :items="types"
                        dense
                        v-model="search.type"
                        outlined
                        placeholder="Select type"
                        hide-selected
                        @change="setFormConditions('type')"
                      ></v-select>
                  </div>
                  <br />
                  <v-btn small class="mr-2" color="primary" @click="navigateTo()">Search</v-btn>&nbsp;&nbsp;&nbsp;<v-btn small class="mr-2" color="primary" @click="resetFields()">Clear</v-btn>
                </v-card-text>
              </v-form>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'CallsignSearch',
    data () {
      return {
        search: {
          callsign: "",
          name: "",
          type: "",
          id: "",
          wing: ''
        },
        inputValue: '',
        types: [
          {text: "Member"},
          {text: "Unit"},
        ],
        rules: {
          required: value => !!value || 'Required.',
          numeric: value => !isNaN(value) || 'Must be numeric.',
          counter: value => value.length <= 4 || 'Max 4 characters.',
        },
        valid: false,
        okToSubmit: false,
        showError: false
      }
    },
    mounted() {
      this.setBackButtonVisibility(true);
      this.setHomeButtonVisibility(true);
      this.search.wing = this.selWing
      this.resetFields();
    },
    methods: {
      setFormConditions(field) {
        switch(field) {
          case "callsign":
            this.search.type=""
            this.search.id=""
            this.search.name=""
            break;
          case "id":
            this.search.type=""
            this.search.callsign=""
            this.search.name=""
            break;
          case "name":
            this.search.callsign=""
            this.search.id=""
            break;
          case "type":
            this.search.callsign=""
            this.search.id=""
            break;
        }
      },
      resetFields() {
        this.search.callsign = ""
        this.search.type=""
        this.search.name=""
        this.search.id=""
        this.showError=false
      },
      validateForm() {
        if(this.search.callsign == '' && this.search.type == '' && this.search.name == '' && this.search.id == '')
        {
          this.okToSubmit = false
        }
        else
        {
          this.okToSubmit = true
        }
      },
      navigateTo() {
        this.validateForm();
        if (this.okToSubmit == true)
        {

          this.setTempCallsignSearch(this.search)
          this.showError=false
          this.$router.push({ name: 'CallsignResults'})
        }
        else
        {
          this.showError = true
        }
      }
    }
  }
</script>

<style scoped>
.fldInput {
  width: 200px;
  max-width:200px;
  margin: auto;
}
</style>
